var map = {
	"./image-launch-vehicle-landscape.jpg": 1,
	"./image-launch-vehicle-portrait.jpg": 24,
	"./image-space-capsule-landscape.jpg": 878,
	"./image-space-capsule-portrait.jpg": 947,
	"./image-spaceport-landscape.jpg": 206,
	"./image-spaceport-portrait.jpg": 328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;